import { Profanity } from "@2toad/profanity";
import { profanityAllowlist, profanityBlocklist } from "./profanity-overrides.js";

export const PROFANITY_ERROR_MESSAGE =
  "Market content violates content guidelines and cannot be saved.";

export const PROFANITY_LANGUAGES = ["ar", "zh", "en", "fr", "de", "hi", "it", "ja", "ko", "pt", "ru", "es"];

const replacementPairs = [
  ["@", "u"],
  ["$", "s"],
  ["!", "i"],
  ["0", "o"],
  ["1", "i"],
  ["3", "e"],
  ["4", "a"],
  ["5", "s"],
  ["7", "t"]
];

const defaultFilter = createProfanityFilter();

export function createProfanityFilter() {
  const filter = new Profanity({
    languages: PROFANITY_LANGUAGES,
    wholeWord: true,
    unicodeWordBoundaries: true
  });

  if (profanityBlocklist.length > 0) {
    filter.addWords(profanityBlocklist);
  }

  if (profanityAllowlist.length > 0) {
    filter.whitelist.addWords(profanityAllowlist);
  }

  return filter;
}

export function isProfaneText(input, filter = defaultFilter) {
  const value = String(input || "").trim();
  if (!value) return false;
  if (hasProfaneToken(value, filter)) return true;
  const normalized = normalizeForModeration(value);
  return normalized !== value && hasProfaneToken(normalized, filter);
}

export function validateMarketContentModeration({ title, summary, options }, filter = defaultFilter) {
  if (isProfaneText(title, filter)) return PROFANITY_ERROR_MESSAGE;
  if (isProfaneText(summary, filter)) return PROFANITY_ERROR_MESSAGE;

  const labels = Array.isArray(options) ? options : [];
  for (const label of labels) {
    if (isProfaneText(label, filter)) return PROFANITY_ERROR_MESSAGE;
  }

  return null;
}

function normalizeForModeration(value) {
  let normalized = String(value || "");
  for (const [from, to] of replacementPairs) {
    normalized = normalized.split(from).join(to);
  }
  return normalized.replace(/[^\p{L}\p{N}\s_-]+/gu, " ").replace(/\s+/g, " ").trim();
}

function hasProfaneToken(value, filter) {
  const tokens = String(value || "").match(/[\p{L}\p{N}_-]+/gu) || [];
  for (const token of tokens) {
    if (token.length < 3) continue;
    if (filter.exists(token)) return true;
  }
  return false;
}
